export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "12px !important",
          backgroundColor: `${theme.palette.grey.g7}`,
          color: `${theme.palette.text.secondary} !important`,
          "&::before": {
            borderBottom: "none !important",
          },
          "&.MuiOutlinedInput": {
            backgroundColor: `${theme.palette.common.white} !important`,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1),
          color: theme.palette.error.main,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
        },
      },
    },
  };
}
